<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
      <v-expansion-panels
        popout
        multiple
        focusable
        hover
      >
        <v-expansion-panel>
          <v-expansion-panel-header>Vows</v-expansion-panel-header>
          <v-expansion-panel-content>

            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn color="primary" @click="showVowDialog = true"><v-icon left>mdi-plus</v-icon>Add</v-btn>
                <v-dialog v-model="showVowDialog" maxWidth="800">
                  <v-card>
                    <v-card-title>
                      Add New Vow
                    </v-card-title>
                    <v-card-text>
                      <v-text-field
                        v-model="newTrackName"
                        label="Vow Name"
                      />
                        <v-select
                          label="Rank"
                          :items="ranks"
                          v-model="newTrackRank"
                        />
                      <v-textarea
                        v-model="newTrackNotes"
                        label="Notes"
                      />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer/>
                      <v-btn @click="closeNewVowDialog" text>Nevermind</v-btn>
                      <v-btn @click="addVow" :disabled="!newTrackName" color="success">Create</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>

            <v-row v-for="track in vowTracks" :key="track.uuid">
              <ProgressTrack :track="track" allow-edit />
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Progress</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn color="primary" @click="showProgressDialog = true"><v-icon left>mdi-plus</v-icon>Add</v-btn>
                <v-dialog v-model="showProgressDialog" maxWidth="800">
                  <v-card>
                    <v-card-title>
                      Add New Progress Track
                    </v-card-title>
                    <v-card-text>
                      <v-text-field
                        v-model="newTrackName"
                        label="Track Name"
                      />
                        <v-select
                          label="Rank"
                          :items="ranks"
                          v-model="newTrackRank"
                        />
                      <v-textarea
                        v-model="newTrackNotes"
                        label="Notes"
                      />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer/>
                      <v-btn @click="closeNewProgressDialog" text>Nevermind</v-btn>
                      <v-btn @click="addTrack" :disabled="!newTrackName" color="success">Create</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>

            <v-row v-for="track in progressTracks" :key="track.uuid">
              <ProgressTrack :track="track" allow-edit />
            </v-row>

          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import ProgressTrack from '@/components/ProgressTrack'
import danger from '@/helpers/danger'
import _ from 'lodash'

  export default {
  components: {
    ProgressTrack
  },
    name: 'Progress',
    computed: {
      ...mapGetters('progress', ['pinnedProgressTrack', 'progressTracks', 'vowTracks']),
      ranks() {
        return _.map(danger.dangerLevels, (value) => {
          return {
            text: value.title,
            value: value.rank
          }
        })
      }
    },
    data() {
      return {
        newTrackName: '',
        newTrackRank: 0,
        newTrackNotes: '',
        showVowDialog: false,
        showProgressDialog: false,
      }
    },
    methods: {
      reset() {
        this.newTrackName = ''
        this.newTrackRank = 0
        this.newTrackNotes = ''
      },

      addTrack() {
        this.$store.dispatch('progress/createProgressTrack', {
          name: this.newTrackName,
          rank: this.newTrackRank,
          notes: this.newTrackNotes,
          isVow: false,
        })
        this.closeNewProgressDialog()
      },

      addVow() {
        this.$store.dispatch('progress/createProgressTrack', {
          name: this.newTrackName,
          rank: this.newTrackRank,
          notes: this.newTrackNotes,
          isVow: true,
        })
        this.closeNewVowDialog()
      },

      closeNewVowDialog() {
        this.showVowDialog = false;
        this.reset()
      },

      closeNewProgressDialog() {
        this.showProgressDialog = false;
        this.reset()
      },
    },
  };
</script>
